import app from '../app';

app.directive('cianEnter', () => {
  return {
    link: (scope, elements, attrs) => {
      elements.bind('keydown keypress', function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.cianEnter);
          });
          event.preventDefault();
        }
      });
    },
  };
});
